import axios from 'axios'
import { Notify } from 'quasar'
import getError from '../utils/api-errors'

const axiosInstance = axios.create({
  baseURL: process.env.API
})

axiosInstance.defaults.headers.common['app-version'] = process.env.VERSION

export default ({ Vue, store, router }) => {
  Vue.prototype.$axios = axiosInstance

  axiosInstance.prototype.cancelError = false

  axiosInstance.interceptors.response.use(
    config => {
      return config
    },
    error => {
      if (error.config.notify !== false) {
        const errors = getError(
          error.response.status,
          error.response.data.code,
          error.response.data.fields || []
        )
        for (const err of errors) {
          Notify.error(err)
        }
        // Notify.error(getError(error.response.status, error.response.data.code))
      }
      if (error.response.status == 401) {
        store.dispatch('auth/clear')
        router.push({ name: 'login-form' })
      }
      return Promise.reject(error)
    }
  )
}

export { axiosInstance }
